// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"2e02cc73","453":"d87325ee"}[chunkId] + ".chunk.js";
};